import { useAppDispatch } from '../../../../hooks/useAppDispatch'
import { useAppSelector } from '../../../../hooks/useAppSelector'
import {
  selectIsShowing,
  selectSearchTerm,
  setIsShowing,
  setSearchTerm,
} from '../../../../store/slices/globalSearchSlice'
import { GLOBAL_SEARCH_INPUT_DOM_ID } from '../constants'

export function useGlobalSearch() {
  const isShowing = useAppSelector(selectIsShowing)
  const searchTerm = useAppSelector(selectSearchTerm)
  const dispatch = useAppDispatch()

  function show() {
    dispatch(setIsShowing(true))
  }

  function hide() {
    dispatch(setIsShowing(false))
  }

  function clear() {
    dispatch(setSearchTerm(''))
  }

  function focus() {
    const searchInput = document.getElementById(GLOBAL_SEARCH_INPUT_DOM_ID)

    if (!searchInput) {
      throw new Error('Expected searchInput to be defined')
    }

    searchInput.focus()
  }

  return {
    searchTerm,
    isShowing,
    show,
    hide,
    setSearchTerm: (searchTerm: string) => {
      dispatch(setSearchTerm(searchTerm))
    },
    focus,
    clear,
  }
}
